import { LayoutType, withLayout } from 'hocs/with-layout';
import { EmailVerifying } from './email-verifying';

const WrappedEmailVerifying = withLayout(LayoutType.Empty, EmailVerifying);

export { WrappedEmailVerifying as EmailVerifying };
